<div class="h-full w-[500px] py-3">
  <aux-file-manager
    #fileManager
    [eager]="false"
    class="h-[306px]"
    [pathFn]="pathFN"
    [fetchFilesOnInit]="true"
    [document_type_id]="documentTypeId"
    (filesRemoved)="removeFileChange($event)"
  ></aux-file-manager>
  @if (fileManager) {
    <div class="mt-4 max-h-[200px] overflow-y-auto">
      <aux-file-viewer
        [fileManager]="fileManager"
        [disableFirstFileMargin]="true"
        [onlyShowUploaded]="false"
        [type]="'edc'"
        [showUserAndDate]="true"
      />
    </div>
  }
</div>
